import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { GlobalConstants } from '../../../common/constants/global.constant';
import { PromoContentService } from '../../../core/routing/services/asset-library/promo-content.service';
import { first } from 'rxjs/internal/operators/first';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { PromoContent } from '../../asset-library/promo-content/interfaces/promo-content.i';
import { CommonService } from './../../../common/services/common.service';
import { AssetLibraryConstants } from '../../../core/routing/services/asset-library/constants/asset-library.constant';
import { environment } from '../../../../environments/environment';
import { DevicesConstants } from '../../../../app/core/routing/services/devices/constants/devices.constants';
import { DeviceStoreService } from '../store/device.store';
import { PromotionalContent } from '../interface/devices-interface.i';
import { GoogleAnalyticsService } from '../../../../app/modules/google-analytics/google-analytics.service'
import { Utils } from '../../../common/utils/utils';
@Component({
  selector: 'iposcen-device-promo-content',
  templateUrl: './device-promo-content.component.html',
  styleUrls: ['./device-promo-content.component.scss']
})
export class DevicePromoContentComponent implements OnInit {
  @Output() readonly dismissFunc = new EventEmitter();
  @Output() readonly lastUpdateTime = new EventEmitter();
  deviceTypes = GlobalConstants.DEVICE_TYPES;
  manufacturers = GlobalConstants.MANUFACTURERS;
  processors = GlobalConstants.PROCESSORS;
  generation = GlobalConstants.GENERATIONS;
  userId = sessionStorage.getItem(GlobalConstants.USER_ID);
  promoContentHeading = GlobalConstants.PROMOTIONAL_CONTENT;
  saveChanges = GlobalConstants.SAVE_CHANGES;
  cancelChanges = GlobalConstants.CANCEL;
  globConst = GlobalConstants;
  allPromoContentGroups: PromoContent[];
  displayPromoContentGroups = [];
  page = 1;
  pageSize = 5;
  maxSize = 5;
  isDevicePromoNone: boolean;
  pageGrpForm: any;
  url = AssetLibraryConstants.S3_ASSET_LIBRARY_USERS + this.userId
    + AssetLibraryConstants.ASSET_LIBRARY_ASSET_LIBRARY + this.userId;
  selctedContGrpsForProfile: any = {
    selectedCG: []
  };
  promotionalContents: PromotionalContent[] = [];
  successMessage: string;
  description: string;
  openModalPopup = false;
  isCancel = false;
  buttonLabelNo = DevicesConstants.NO;
  buttonLabelCancel = DevicesConstants.CANCEL_UPDATE;
  isSelectedData = new Map();
  isPromoEmpty: boolean;
  sortValue: string;
  isIdleExperienceEnabled:string = GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IPOS;
  isCheckedPreview: boolean;
  private ngUnsubscribe = new Subject<boolean>();

  constructor(
    private promoContentService: PromoContentService,
    private deviceStore: DeviceStoreService,
    private cmnService: CommonService,
    private googleAnalyticsService: GoogleAnalyticsService
  ) { }

  ngOnInit(): void {
    this.isDevicePromoNone = false;
    this.isCheckedPreview = true;
    this.getAllPromoContentsByUser();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  getAllPromoContentsByUser() {
    this.googleAnalyticsService.devieInfoTabName('Promotional Content');
    this.promoContentService.getAllPromoContentByUser()
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(getAllPromoContentResponse => {
        this.allPromoContentGroups = (getAllPromoContentResponse.promotionalContent as PromoContent[]);
        // display Promo content groups using displayPromocontentgroups var as configurations is coming as string
        this.displayPromoContentGroups = [];
        this.allPromoContentGroups.forEach(ele => {
          ele.configurations = JSON.parse(ele.configurations);
          this.displayPromoContentGroups.push(ele);
        });
        this.isPromoEmpty = (this.displayPromoContentGroups.length == 0) || false;
        this.displayPromoContentGroups.forEach(element => {
          // adding this custom property to know which Promo content is expanded and check
          element.isExpanded = false;
          element.isIdleExperienceEnabled = GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IPOS;
          element.selectedCG = false;
          if (element.updateTime) {
            element.updateTime = new Date(element.updateTime);
            element.updateTimeDisplay = new Date(element.updateTime).toLocaleString()
              .replace(',', '');
          }
           // For content expired notification
           element.isContentExpires = Utils.getExpiredUnChangedContentdata(element);
          //To format Formfactors for UI
          element.configurations.formFactor = Utils.getFormFactorNames(element.configurations.formFactor);
        });
        this.sortByDate();
        const storeData = this.deviceStore.deviceStoreData;
        if (storeData?.promotionalContents.length == 0) this.isDevicePromoNone = true;
        if (storeData?.promotionalContents) {
          storeData.promotionalContents
            .forEach(element => {
              this.isSelectedData.set(element.promotionalContentId, true);
            });
          this.selctedContGrpsForProfile.selectedCG = Array.from(this.isSelectedData.keys());
        } else {
          this.selctedContGrpsForProfile = {
            selectedCG: []
          };
        }
      },
        error => {
          this.isPromoEmpty = true;
        });
  }
  sortByDate() {
    this.page = 1;
    this.sortValue = GlobalConstants.CREATED_DATE;
    this.displayPromoContentGroups.sort((promo1, promo2) => promo2.updateTime - promo1.updateTime);
  }
  getDetailsOfPromoCG(id: string) {
    this.displayPromoContentGroups.forEach(element => {
      if (element.id === id) {
        element.isExpanded = !element.isExpanded;
        element.isIdleExperienceEnabled = GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IPOS;
        this.cmnService.scrollToBottom(id);
      }
    });
    this.isIdleExperienceEnabled = GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IPOS;
  }

  // minipreview image or video content
  loadMiniPreview(gId: string, pageContent: any) {
    this.pageGrpForm = {
      bgcolor: pageContent ? pageContent.bgColor : '#0068B5',
      heading: pageContent ? pageContent.title : '',
      hcolor: pageContent ? pageContent.titleFontColor : '#ffffff',
      body: pageContent ? pageContent.bodyCopy : '',
      bcolor: pageContent ? pageContent.bodyCopyFontColor : '#ffffff',
      size: pageContent ? this.getFontSize(pageContent.bodyCopyFontSize) : GlobalConstants.MEDIUM,
      media: {
        url: (pageContent && pageContent.linkedAsset) ?
          environment.apiBaseUrlAsset + this.url +
          AssetLibraryConstants.PROMO_CONTENTS +
          AssetLibraryConstants.SLASH + gId +
          AssetLibraryConstants.SLASH + pageContent.pageNum.toString() : '',
        name: '',
        format: (pageContent && pageContent.linkedAsset) ? (pageContent.linkedAssetFileType) ? pageContent.linkedAssetFileType : '' : '',
        fileObj: ''
      },
      id: gId,    // adding created group id,
      layout: pageContent ? this.getUILayoutIDByName(pageContent.UiLayout) : 1,
      previewType: pageContent ? pageContent.previewType : '',
      idleExpFullscreenEnabled: pageContent ? pageContent.idleExpFullscreenEnabled : '',
      fullScreenCheckbox: pageContent ? pageContent?.fullScreenCheckbox ? 
      pageContent.fullScreenCheckbox : false : true,
    };

    return this.pageGrpForm;
  }

  getFontSize(size: number) {
    if (size === GlobalConstants.NUMBER_12) { return GlobalConstants.SMALL; }
    if (size === GlobalConstants.NUMBER_14) { return GlobalConstants.MEDIUM; }
    if (size === GlobalConstants.NUMBER_16) { return GlobalConstants.LARGE; }
  }

  getUILayoutIDByName(name: string) {
    if (name === GlobalConstants.TWO_COL_RIGHT_ASSET) {
      return 1;
    } else if (name === GlobalConstants.TWO_COL_LEFT_ASSET) {
      return 2;
    } else if (name === GlobalConstants.ONE_COL_MID_ASSET) {
      return 3;
    }
  }

  // check uncheck content groups
  selectContentGroup(eventObj: any, index: number, promo) {
    if (this.isSelectedData.has(promo.id)) {
      this.isSelectedData.delete(promo.id);
      this.selctedContGrpsForProfile.selectedCG = Array.from(this.isSelectedData.keys());
    } else {
      this.isSelectedData.set(promo.id, true);
      this.selctedContGrpsForProfile.selectedCG = Array.from(this.isSelectedData.keys());
    } 
    if(this.isSelectedData.size > 0) {
      this.isDevicePromoNone = false;
    }
  }

  cancel() {
    this.successMessage = DevicesConstants.DEVICE_CANCEL_TITLE;
    this.description = DevicesConstants.DEVICE_CANCEL_DESC;
    this.isCancel = true;
    this.openModalPopup = !this.openModalPopup;
  }

  closeModal() {
    this.openModalPopup = !this.openModalPopup;
  }

  dismiss() {
    this.dismissFunc.emit('');
    this.openModalPopup = !this.openModalPopup;
    this.isCancel = false;
  }

  sendDataToStore() {
    this.googleAnalyticsService.devieInfoChangesSaved('Promotional Content');
    this.openModalPopup = !this.openModalPopup;
    this.successMessage = DevicesConstants.DEVICE_UPDATE_SAVED;
    this.description = DevicesConstants.DEVICE_UPDATE_DESC;
    this.promotionalContents = [];
    this.isSelectedData.forEach((val, key, item) => {
      const segmentList = {
        promotionalContentId: key,
        showOnDevice: true
      };
      this.promotionalContents.push(segmentList);
    });

    this.deviceStore.updateDeviceData({ promotionalContents: this.promotionalContents });
    this.isCancel = false;
    this.lastUpdateTime.emit(true);
  }
  removeShowonDeveice() {
    this.isDevicePromoNone = true;
    this.isSelectedData.clear();
    this.selctedContGrpsForProfile.selectedCG=[];
  }
  togglePreviewTabs(previewType, id) {
    this.isIdleExperienceEnabled = previewType;
    this.displayPromoContentGroups.forEach(element => {
      if (element.id === id) {
        element.isIdleExperienceEnabled = this.isIdleExperienceEnabled;
      }
    });
  }
}
